import React, { Component } from "react";
import Slider from "react-slick";
import "./Carousel.css";
import W1 from "../../../../../assets/icons/W1@1.5x.png";
import W2 from "../../../../../assets/icons/W2@1.5x.png";
import W3 from "../../../../../assets/icons/W3@1.5x.png";
import W4 from "../../../../../assets/icons/W4@1.5x.png";
import W5 from "../../../../../assets/icons/W5@1.5x.png";
import W6 from "../../../../../assets/icons/W6@1.5x.png";
import W7 from "../../../../../assets/icons/W7@1.5x.png";
import WM1 from "../../../../../assets/icons/WM1@1.5x.png";
import WM2 from "../../../../../assets/icons/WM2@1.5x.png";
import WM3 from "../../../../../assets/icons/WM3@1.5x.png";
import WM4 from "../../../../../assets/icons/WM4@1.5x.png";
import WM5 from "../../../../../assets/icons/WM5@1.5x.png";
import WM6 from "../../../../../assets/icons/WM6@1.5x.png";
import WM7 from "../../../../../assets/icons/WM7@1.5x.png";
import right_arrow from "../../../../../assets/icons/right-arrow.png";
import cross_with_round from "../../../../../assets/icons/cross-with-round.png";
import left_arrow_with_round from "../../../../../assets/icons/left-arrow-with-round.png";

function NextArrow(props) {
  const { className, onClick, currentSlide, slideCount, id } = props;

  if (currentSlide !== slideCount - 1) {
    return (
      <img
        id={props.id}
        alt="right Arrow"
        src={right_arrow}
        width={20}
        className={className}
        onClick={onClick}
      />
    );
  } else {
    return (
      <div className="slider-container">
        <img
          src={cross_with_round}
          width={20}
          className={className}
          onClick={props.closeWalkThrough}
          alt="cross arrow"
        />
      </div>
    );
  }
}

function PrevArrow(props) {
  const { className, onClick, currentSlide, slideCount, id } = props;

  return (
    <img
      id={props.id}
      alt="left arrow"
      src={left_arrow_with_round}
      className={className}
      onClick={onClick}
    />
  );
}

export default class SimpleSlider extends Component {
  render() {
    const { closeWalkThrough } = this.props;
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow closeWalkThrough={closeWalkThrough} id="btnNextArrow" />,
      prevArrow: <PrevArrow closeWalkThrough={closeWalkThrough} id="btnPrevArrow" />
    };
    return (
      <div className="slider-width">
        <Slider {...settings}>
          <div>
            <picture>
              <source
                type="image/png"
                media="(max-width: 991px)"
                srcset={WM1}
              />
              <source type="image/png" media="(min-width: 992px)" srcset={W1} />
              <img src={W1} alt={0} width="100%" />
            </picture>
          </div>
          <div>
            <picture>
              <source
                type="image/png"
                media="(max-width: 991px)"
                srcset={WM2}
              />
              <source type="image/png" media="(min-width: 992px)" srcset={W2} />
              <img src={W2} alt={1} width="100%" />
            </picture>
          </div>
          <div>
            <picture>
              <source
                type="image/png"
                media="(max-width: 991px)"
                srcset={WM3}
              />
              <source type="image/png" media="(min-width: 992px)" srcset={W3} />
              <img src={W3} alt={2} width="100%" />
            </picture>
          </div>
          <div>
            <picture>
              <source
                type="image/png"
                media="(max-width: 991px)"
                srcset={WM4}
              />
              <source type="image/png" media="(min-width: 992px)" srcset={W4} />
              <img src={W4} alt={3} width="100%" />
            </picture>
          </div>
          <div>
            <picture>
              <source
                type="image/png"
                media="(max-width: 991px)"
                srcset={WM5}
              />
              <source type="image/png" media="(min-width: 992px)" srcset={W5} />
              <img src={W5} alt={4} width="100%" />
            </picture>
          </div>
          <div>
            <picture>
              <source
                type="image/png"
                media="(max-width: 991px)"
                srcset={WM6}
              />
              <source type="image/png" media="(min-width: 992px)" srcset={W6} />
              <img src={W6} alt={5} width="100%" />
            </picture>
          </div>
          <div>
            <picture>
              <source
                type="image/png"
                media="(max-width: 991px)"
                srcset={WM7}
              />
              <source type="image/png" media="(min-width: 992px)" srcset={W7} />
              <img src={W7} alt={6} width="100%" />
            </picture>
          </div>
        </Slider>
      </div>
    );
  }
}
